import { render, staticRenderFns } from "./BookReview.vue?vue&type=template&id=0bda019a&scoped=true"
import script from "./BookReview.vue?vue&type=script&lang=js"
export * from "./BookReview.vue?vue&type=script&lang=js"
import style0 from "./BookReview.vue?vue&type=style&index=0&id=0bda019a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bda019a",
  null
  
)

export default component.exports